function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgShare = function SvgShare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "transparent"
    },
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 17720",
    d: "M7.736 11.616a2.506 2.506 0 0 0 0-2.236m0 2.236a2.5 2.5 0 1 1 0-2.236m0 2.236 5.525 2.763m-5.525-5 5.525-2.763m0 0a2.5 2.5 0 1 0 1.118-3.354 2.5 2.5 0 0 0-1.118 3.354zm0 7.761a2.5 2.5 0 1 0 3.354-1.118 2.5 2.5 0 0 0-3.354 1.12z",
    transform: "translate(1.501 .753)",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }));
};

export default SvgShare;